module.exports = __webpack_public_path__ + "img/mind_background_6_th.e9d41df9.png";